import React, { FC } from 'react';

import { format, parseISO } from 'date-fns';

import { ReactComponent as EyeSvg } from 'assets/svg/eye.svg';
import { DAY_FORMAT_WITH_HOURS } from 'constants/dateFormats';
import { ButtonVariants } from 'constants/shared/button';
import { CustomMailSent } from 'interfaces/custom-mail';
import { Button } from 'shared-components';
import { TableData, TableRow } from 'shared-components/table';

type Props = {
  mail: CustomMailSent;
  handleOpenModal: () => void;
};

const SentMailsTableRow: FC<Props> = ({ mail, handleOpenModal }) => (
  <TableRow>
    <TableData>{mail.email}</TableData>
    <TableData>{mail.subject}</TableData>
    <TableData className='max-w-[200px] overflow-hidden text-ellipsis whitespace-nowrap'>{mail.body}</TableData>
    <TableData>{format(parseISO(mail.createdAt), DAY_FORMAT_WITH_HOURS)}</TableData>
    <TableData>
      <Button
        variant={ButtonVariants.TRANSPARENT}
        className='w-[50px] h-full float-right'
        onClick={() => {
          handleOpenModal();
        }}
      >
        <EyeSvg className='fill-blue-800' />
      </Button>
    </TableData>
  </TableRow>
);

export default SentMailsTableRow;
